module.exports = "/static/media/delete_icon.26878c41.svg";